import store from "@/store";
import api, { cancelAllRequests } from "@/interceptors";
import { UserRoute } from "../apiRoutes/routes";
import { IApiPromise } from "@/interfaces/responseData";
import { IUserProfile, IUserProfileImage } from "@/interfaces/userInterfaces";
import { showSuccessToast } from "../apiRoutes";
import { getComponentUiText } from "@/utils/utilities";

export default {
  login: function (data: any): any {
    return new Promise((resolve, reject) => {
      api
        .post(UserRoute.login, {
          email: data.email,
          password: data.password,
        })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getMFASetupInfo: function () {
    return new Promise((resolve, reject) => {
      api
        .get(UserRoute.mfaEnable)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  confirmMFAToken: function (data: any) {
    return new Promise((resolve, reject) => {
      api
        .post(UserRoute.mfaConfirm, data)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  verifyMFAToken: function (data: any) {
    return new Promise((resolve, reject) => {
      api
        .post(UserRoute.mfaVerify, data)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  mfaFido2Register: function () {
    return new Promise((resolve, reject) => {
      api
        .post(UserRoute.mfaFido2Register)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  mfaFido2Activate: function (data: any) {
    return new Promise((resolve, reject) => {
      api
        .post(UserRoute.mfaFido2Activate, data)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  mfaFido2Verify: function (data: any) {
    return new Promise((resolve, reject) => {
      api
        .post(UserRoute.mfaFido2Verify, data)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  logout: function (): any {
    return new Promise((resolve, reject) => {
      api
        .post(UserRoute.logout)
        .then((result) => {
          store.dispatch("User/unauthenticateUser");
          cancelAllRequests();
          resolve(result);
          showSuccessToast(getComponentUiText("app-api-log-out-success-1"));
        })
        .catch((error) => {
          store.dispatch("User/setActiveCallApi", true);
          reject(error);
        });
    });
  },

  forgotPassword: function (email: string, recaptcha): any {
    return new Promise((resolve, reject) => {
      api
        .post(
          UserRoute.passwrodReset,
          {
            email,
          },
          {
            params: { "g-recaptcha-response": recaptcha },
          } as any,
        )
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetPassword: function (
    token: string,
    password: string,
    tokenRecaptcha: string,
    secret?: string,
  ): any {
    return new Promise((resolve, reject) => {
      const body = {
        secret,
        password,
        token,
      };
      const params = {
        "g-recaptcha-response": tokenRecaptcha,
      };
      api
        .post(UserRoute.passwrodResetCallback, body, { params })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateUserProfile: function (data: any): any {
    return new Promise((resolve, reject) => {
      api
        .put(UserRoute.profileUpdate, data)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  mfaWebauthnRegister: function () {
    return new Promise((resolve, reject) => {
      api
        .get(UserRoute.mfaWebauthnRegister)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  mfaWebauthnVerifyRegister: function (data: any) {
    return new Promise((resolve, reject) => {
      api
        .post(UserRoute.mfaWebauthnVerifyRegister, data)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  mfaWebauthnAuthenticate: function () {
    return new Promise((resolve, reject) => {
      api
        .get(UserRoute.mfaWebauthnAuthenticate)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  mfaWebauthnVerifyAuthentication: function (data: any) {
    return new Promise((resolve, reject) => {
      api
        .post(UserRoute.mfaWebauthnVerifyAuthentication, data)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getUserProfile: (userId: string): IApiPromise<IUserProfile> =>
    api.get(UserRoute.getUserProfile.replace(":userId", userId)),

  getUserProfileImage: (imageId: string): IApiPromise<IUserProfileImage> =>
    api.get(UserRoute.getUserProfileImage.replace(":imageId", imageId)),

  getSalutations: (): IApiPromise<any[]> => api.get(UserRoute.getSalutations),

  resetMfaAuthenApp: (): IApiPromise<any[]> => api.post(UserRoute.mfaDisable),

  postRecentSearches: (searchTypeId, params): IApiPromise<any> =>
    api.post(
      UserRoute.apiRecentSearches.replace(
        ":searchTypeId",
        searchTypeId.toString(),
      ),
      {
        searchData: params,
      },
    ),

  getRecentSearches: (searchTypeId): IApiPromise<any> =>
    api.get(UserRoute.getRecentSearches, {
      params: {
        searchTypeId,
        returnCount: 5,
      },
    }),

  deleteRecentSearches: (searchTypeId): IApiPromise<any> =>
    api.delete(
      UserRoute.apiRecentSearches.replace(
        ":searchTypeId",
        searchTypeId.toString(),
      ),
    ),
};
